import Vue from 'vue';
import { LEAD_STATUSES } from '@/constants';

const EventBus = new Vue();

const substactPercentage = (value, percentage) => {
  return value / 100 * ( 100 - percentage );
};

const objectSortedByKeys = (obj = {}) => {
  const sortedObj = Object.keys(obj).sort().reduce((newObj, key) => {
    newObj[key] = obj[key];
    return newObj;
  }, {});

  return sortedObj;
};

const leadsTablesStatusSort = (items, sortBy, sortDesc) => {
  if (sortBy[0] === 'status') {
    // CUSTOM STATUS SORTING
    items.sort((nextItem, currentItem) => {
      const indexA = Object.values(LEAD_STATUSES).indexOf(nextItem[sortBy]);
      const indexB = Object.values(LEAD_STATUSES).indexOf(currentItem[sortBy]);
      if ( sortDesc[0] ) {
        return indexB - indexA;
      } else {
        return indexA - indexB;
      }
    });
  } else if ( sortBy.length > 0 ) {
    // DEFAULT SORTING
    items.sort((nextItem, currentItem) => {
      if ( sortDesc[0] ) {
        return currentItem[sortBy].toLowerCase().localeCompare(nextItem[sortBy]);
      } else {
        return nextItem[sortBy].toLowerCase().localeCompare(currentItem[sortBy]);
      }
    });
  }

  return items;
};

export { EventBus, substactPercentage, objectSortedByKeys, leadsTablesStatusSort };



// WEBPACK FOOTER //
// ./src/utilities/index.js